module.exports = __webpack_public_path__ + "img/tx.8add7cdd.png";